import { Routes } from '@angular/router';

import { EGoogleLib } from '@shared/models';
import { mapLibraryResolver } from '@shared/services/map-loader.resolver';
import { permissionGuard } from '@core/guards';

export const passengerRoutes: Routes = [
  {
    path: 'passengers',
    loadComponent: () =>
      import('@feature/passenger/passenger.component').then(
        m => m.PassengerComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'students',
      },
      {
        path: 'families',
        loadComponent: () =>
          import('./families/families.component').then(
            m => m.FamiliesComponent
          ),
        children: [
          {
            path: '',
            canActivate: [permissionGuard('DispatcherGuardiansView')],
            loadComponent: () =>
              import('./families/components/families-grid/families-grid.component').then(
                m => m.FamiliesGridComponent
              ),
          },
          {
            path: 'new-family',
            resolve: { lib: mapLibraryResolver(EGoogleLib.places) },
            canActivate: [permissionGuard('DispatcherGuardiansCreate')],
            loadComponent: () =>
              import('./families/components/add-edit-new-family/add-edit-new-family.component').then(
                m => m.AddEditNewFamilyComponent
              ),
          },
          {
            path: 'edit-family',
            resolve: {
              lib: mapLibraryResolver(EGoogleLib.places, EGoogleLib.marker),
            },
            canActivate: [permissionGuard('DispatcherGuardiansEdit')],
            loadComponent: () =>
              import('./families/components/add-edit-new-family/add-edit-new-family.component').then(
                m => m.AddEditNewFamilyComponent
              ),
          },
        ],
      },
      {
        path: 'students',
        loadComponent: () =>
          import('./students/students.component').then(
            m => m.StudentsComponent
          ),
        children: [
          {
            path: '',
            canActivate: [permissionGuard('DispatcherStudentsView')],
            loadComponent: () =>
              import('./students/components/students-grid/students-grid.component').then(
                m => m.StudentsGridComponent
              ),
          },
          {
            path: 'new-student',
            resolve: { lib: mapLibraryResolver(EGoogleLib.places) },
            canActivate: [permissionGuard('DispatcherStudentsCreate')],
            loadComponent: () =>
              import('./students/components/add-edit-new-student/add-edit-new-student.component').then(
                m => m.AddEditNewStudentComponent
              ),
          },
          {
            path: 'edit-student/:id',
            resolve: { lib: mapLibraryResolver(EGoogleLib.places) },
            canActivate: [permissionGuard('DispatcherStudentsEdit')],
            loadComponent: () =>
              import('./students/components/add-edit-new-student/add-edit-new-student.component').then(
                m => m.AddEditNewStudentComponent
              ),
          },
        ],
      },
      {
        path: 'cancellation-requests',
        canActivate: [
          permissionGuard('DispatcherRideCancellationRequestsView'),
        ],
        loadComponent: () =>
          import('./cancellation-requests/cancellation-requests.component').then(
            m => m.CancellationRequestsComponent
          ),
      },
    ],
  },
];
